import { createContext, useRef, useState } from "react";
import { TERRADRAW_DEFAULT_COLORS } from "../constants/Constant";
import { loadState } from "../utils/SaveStateUtil";

// マップのコンテキスト
export const MapContext = createContext(null);

// マップのプロバイダ
export const MapProvider = ({ children }) => {
  // マップオブジェクト
  const [map, setMap] = useState(null);
  // 図形コントロール
  const [drawCtl, setDrawCtl] = useState(null);
  // 図形色設定
  const drawColorRef = useRef({
    default: loadState("defaultDrawColor") ?? TERRADRAW_DEFAULT_COLORS,
  });
  // 初回表示時のURLハッシュ
  const [hasUrlHash, setHasUrlHash] = useState(null);
  // 次回終了状態再現フラグ
  const [isCheckSaveState, setIsCheckSaveState] = useState(
    () => loadState("checkMapState")?.isCheckSaveState ?? false
  );
  // 購入履歴の反映フラグ
  const [isReflectHistoryOnMap, setIsReflectHistoryOnMap] = useState(
    () => loadState("isReflectHistoryOnMap") ?? false
  );
  // 選択された地物 画面表示はuseStateの値を参照し、データ操作はuseRefの配列を使用する
  const [selectedFeatures, setSelectedFeatures] = useState([]);
  const featuresRef = useRef([]);
  const addSelectedFeatures = (features, { kind = "kokyo", lngLat = null } = {}) => {
    if (features) {
      const featureArray = Array.isArray(features) ? features : [features];
      // 種別（公共座標/任意座標）とクリック点を付与
      featureArray.forEach((feature) => {
        feature.__kind = kind;
        feature.__lngLat = lngLat;
      });
      featuresRef.current = [...featuresRef.current, ...featureArray];
      setSelectedFeatures(featuresRef.current);
    }
  };
  const deleteSelectedFeatures = () => {
    featuresRef.current = [];
  };

  return (
    <MapContext.Provider
      value={{
        map,
        setMap,
        drawCtl,
        setDrawCtl,
        drawColorRef,
        hasUrlHash,
        setHasUrlHash,
        isCheckSaveState,
        setIsCheckSaveState,
        isReflectHistoryOnMap,
        setIsReflectHistoryOnMap,
        selectedFeatures,
        addSelectedFeatures,
        deleteSelectedFeatures,
      }}
    >
      {children}
    </MapContext.Provider>
  );
};
